export const AB_TEST_TYPES = {
    STANDARD: 'STANDARD',
    RESPONSIVE: 'RESPONSIVE',
    MOBILE: 'MOBILE',
} as const;

export const AB_TEST_VALUES = {
    CONTROL: 'CONTROL',
    VARIANT: 'VARIANT',
    INELIGIBLE: 'INELIGIBLE',
} as const;

export const ABE_QUERY_PARAM = 'abe';
export const ABE_QUERY_PARAM_VALUES = {
    CONTROL: 'sc',
    DEFAULT: 'default',
    CDN_TEST_1: 'cdnTest1',
    CDN_TEST_2: 'cdnTest2',
    CDN_TEST_3: 'cdnTest3',
    CDN_TEST_4: 'cdnTest4',
} as const;

export const SEO_TEST = {
    FALSE: 'FALSE',
    TRUE: 'TRUE',
    SEO_ONLY: 'SEO_ONLY',
} as const;

export type AbTestTypeType = typeof AB_TEST_TYPES[keyof typeof AB_TEST_TYPES];
export type AbTestValueType = typeof AB_TEST_VALUES[keyof typeof AB_TEST_VALUES];
export type SeoTestType = typeof SEO_TEST[keyof typeof SEO_TEST];
